import {FACILITY_CATEGORY} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'

export default class FacilityForAdmin {
    facilityId: number
    facilityName: string
    categoryId: number
    categoryName: string
    sortOrder: number
    lotteryAvailability: boolean
    stayAvailability: boolean
    stayPossibleDateCount: Nullable<number>
    releaseSetting: boolean
    releaseStartDateTime: Nullable<string>
    reserveLotteryStart: Nullable<string>
    reserveLotteryEnd: Nullable<string>
    reserveConfirmLimit: Nullable<string>
    reserveLotteryMonth: Nullable<number>
    reserveFasterPeriod: Nullable<number>
    updateDatetime: string

    constructor(
        facilityId: number,
        facilityName: string,
        categoryId: number,
        categoryName: string,
        sortOrder: number,
        lotteryAvailability: boolean,
        stayAvailability: boolean,
        stayPossibleDateCount: Nullable<number>,
        releaseSetting: boolean,
        releaseStartDateTime: Nullable<string>,
        reserveLotteryStart: Nullable<string>,
        reserveLotteryEnd: Nullable<string>,
        reserveConfirmLimit: Nullable<string>,
        reserveLotteryMonth: Nullable<number>,
        reserveFasterPeriod: Nullable<number>,
        updateDatetime: string,
    ) {
        this.facilityId = facilityId
        this.facilityName = facilityName
        this.categoryId = categoryId
        this.categoryName = categoryName
        this.sortOrder = sortOrder
        this.lotteryAvailability = lotteryAvailability
        this.stayAvailability = stayAvailability
        this.stayPossibleDateCount = stayPossibleDateCount
        this.releaseSetting = releaseSetting
        this.releaseStartDateTime = releaseStartDateTime
        this.reserveLotteryStart = reserveLotteryStart
        this.reserveLotteryEnd = reserveLotteryEnd
        this.reserveConfirmLimit = reserveConfirmLimit
        this.reserveLotteryMonth = reserveLotteryMonth
        this.reserveFasterPeriod = reserveFasterPeriod
        this.updateDatetime = updateDatetime
    }

    static from(json: any): FacilityForAdmin {
        return new FacilityForAdmin(
            json.facilityId,
            json.facilityName,
            json.categoryId,
            FACILITY_CATEGORY.codeToEnumConstants(`${json.categoryId}`).label,
            json.sortOrder,
            json.lotteryAvailability,
            json.stayAvailability,
            json.stayPossibleDateCount,
            json.releaseSetting,
            json.releaseStartDateTime || null,
            json.reserveLotteryStart || null,
            json.reserveLotteryEnd || null,
            json.reserveConfirmLimit || null,
            json.reserveLotteryMonth || null,
            json.reserveFasterPeriod || null,
            json.updateDatetime,
            )
    }
}
